import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/notes-center")({
  beforeLoad: ({ context }) => guardRoute(context.me, "notes-center"),
  component: Outlet,
});
